export function classNames(...classes: Array<unknown>) {
  return classes.filter(Boolean).join(' ')
}
